var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5088 3.92868L35.6651 4.33501L36.0714 1.49134C36.2481 0.255322 34.7426 -0.500147 33.8583 0.38501L28.6413 5.60204C28.4417 5.80157 28.3123 6.06056 28.2723 6.33993L27.6817 10.4743L21.2406 16.9155C20.7305 16.6714 20.1663 16.5234 19.5641 16.5234C17.4066 16.5234 15.6514 18.2786 15.6514 20.4362C15.6514 22.5938 17.4066 24.3489 19.5641 24.3489C21.7217 24.3489 23.4769 22.5938 23.4769 20.4362C23.4769 19.834 23.3289 19.2699 23.0849 18.7598L29.526 12.3186L33.6604 11.728C33.9398 11.6881 34.1987 11.5586 34.3983 11.3591L39.6153 6.14204C40.4969 5.26024 39.7505 3.7547 38.5088 3.92868Z",
    fill: "#CECABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1453 15.3883L26.0133 19.52C26.0558 19.8202 26.0854 20.1245 26.0854 20.4362C26.0854 24.0322 23.1602 26.9575 19.5641 26.9575C15.9681 26.9575 13.0429 24.0322 13.0429 20.4362C13.0429 16.8402 15.9681 13.915 19.5641 13.915C19.8758 13.915 20.18 13.9445 20.4801 13.987L24.612 9.85503C23.0804 9.12128 21.3728 8.698 19.5641 8.698C13.0917 8.698 7.82587 13.9639 7.82587 20.4363C7.82587 26.9087 13.0917 32.1746 19.5641 32.1746C26.0366 32.1746 31.3024 26.9087 31.3024 20.4363C31.3024 18.6275 30.8792 16.92 30.1453 15.3883Z",
    fill: "#CECABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2846 12.1612L36.2425 13.2033C35.6481 13.7982 34.8618 14.1913 34.0293 14.3101L32.6152 14.5122C33.4395 16.3207 33.9109 18.3225 33.9109 20.4361C33.9109 28.347 27.4749 34.7829 19.5641 34.7829C11.6532 34.7829 5.21726 28.347 5.21726 20.4361C5.21726 12.5253 11.6533 6.08935 19.5641 6.08935C21.6777 6.08935 23.6795 6.56067 25.488 7.38497L25.69 5.97091C25.8088 5.13833 26.202 4.35208 26.7968 3.75724L27.8387 2.71552C25.2686 1.51185 22.4667 0.872314 19.564 0.872314C8.77632 0.872314 0.000228882 9.64849 0.000228882 20.4361C0.000228882 31.2238 8.7764 40 19.5641 40C30.3517 40 39.1279 31.2238 39.1279 20.4361C39.1279 17.5333 38.4884 14.7313 37.2846 12.1612Z",
    fill: "#CECABE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3);
export default __webpack_public_path__ + "static/media/w3.9cf39266246cf371418a5fba0172e97b.svg";
export { ForwardRef as ReactComponent };